"use client";

import { usePrivacyChoice } from "@/lib/privacy-preferences";
import { useEffect } from "react";

/**
 * Fire-once-per-session marketing attribution beacon. On first landing with any
 * utm_* / code params, POST them to /api/track/utm so the admin Attribution
 * dashboard can aggregate where traffic comes from. No-op without params.
 */
export default function UtmBeacon() {
  const choice = usePrivacyChoice();
  useEffect(() => {
    if (choice !== "accepted") return;
    try {
      const sp = new URLSearchParams(window.location.search);
      const source = sp.get("utm_source");
      const medium = sp.get("utm_medium");
      const campaign = sp.get("utm_campaign");
      const code = sp.get("code");
      if (!source && !medium && !campaign && !code) return;

      // One beacon per browser session per unique param-set.
      const sig = `${source ?? ""}|${campaign ?? ""}|${code ?? ""}`;
      const key = "blaundry.utm.sent";
      const already = sessionStorage.getItem(key);
      if (already === sig) return;
      sessionStorage.setItem(key, sig);

      let sid = sessionStorage.getItem("blaundry.sid");
      if (!sid) {
        sid = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
        sessionStorage.setItem("blaundry.sid", sid);
      }

      const payload = JSON.stringify({
        optional_consent: true,
        source,
        medium,
        campaign,
        code,
        path: window.location.pathname,
        referrer: document.referrer || null,
        session_id: sid,
      });
      // keepalive so it survives the navigation that often follows a landing.
      fetch("/api/track/utm", { method: "POST", headers: { "Content-Type": "application/json" }, body: payload, keepalive: true }).catch(() => {});
    } catch {
      /* ignore */
    }
  }, [choice]);

  return null;
}
